import React from 'react';
import { Box, IconSvg } from '@utex/ui-kit';

export const Loader = () => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" flexGrow={1}>
      <IconSvg src="preloader" width={44} height={44} />
    </Box>
  );
};
